import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, notification } from 'antd';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getErrorMessage } from './useGetErrorMessage';

const { confirm } = Modal;

interface PropsDelete {
  content: React.ReactNode;
  loading: boolean;
  error: Error | undefined;
  actionDelete: (id: string) => void;
  recordId: string;
  setRefreshList?: (refresh: boolean) => void;
  refresh?: () => void;
}

type ActionItemValue = string | { id?: string };

const resolveId = (value: ActionItemValue): string | undefined => {
  if (typeof value === 'string') {
    return value || undefined;
  }
  return value?.id || undefined;
};

export const useHandleActionItem = () => {
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleClickEdit = (value: ActionItemValue) => {
    const id = resolveId(value);
    if (!id) {
      return;
    }
    const newQueryParameters = new URLSearchParams(currentQueryParameters);
    newQueryParameters.set('id', id);
    newQueryParameters.set('action', 'Detail');
    setSearchParams(newQueryParameters);
    setOpen(true);
  };

  const handleClickDuplicate = (value: ActionItemValue) => {
    const id = resolveId(value);
    if (!id) {
      return;
    }
    const newQueryParameters = new URLSearchParams(currentQueryParameters);
    newQueryParameters.set('id', id);
    newQueryParameters.set('action', 'Duplicate');
    setSearchParams(newQueryParameters);
    setOpen(true);
  };

  const handleClose = () => {
    const action = currentQueryParameters.get('action');
    const id = currentQueryParameters.get('id');
    if ((action && id) || action) {
      const newQueryParameters = new URLSearchParams(currentQueryParameters);
      newQueryParameters.delete('action');
      newQueryParameters.delete('id');
      setSearchParams(newQueryParameters);
    }
    setOpen(false);
  };

  const handleClickCreate = () => {
    const newQueryParameters = new URLSearchParams(currentQueryParameters);
    newQueryParameters.delete('id');
    newQueryParameters.set('action', 'Create');
    setSearchParams(newQueryParameters);
    setOpen(true);
  };

  const showConfirmDelete = (props: PropsDelete) => {
    const { content, error, actionDelete, recordId, setRefreshList, refresh } = props;
    confirm({
      title: 'Confirm Delete',
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        try {
          actionDelete(recordId);
          if (setRefreshList) {
            setRefreshList(true);
          } else if (refresh) {
            refresh();
          }
        } catch (e) {
          notification.error({
            message: 'Error',
            description: getErrorMessage(error),
            placement: 'bottomRight',
          });
        }
      },
    });
  };

  return {
    handleClickEdit,
    handleClickDuplicate,
    open,
    handleClose,
    setOpen,
    handleClickCreate,
    openModal,
    setOpenModal,
    showConfirmDelete,
  };
};
